<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card class="pa-3">
          <v-layout row wrap pb-4>
            <v-flex md4>
              <v-autocomplete
                label="Company"
                v-model="reportFilters.employer_id"
                :items="
                  getTV(employers, {
                    textField: 'name',
                    valueField: 'id',
                    isDeselect: false,
                  })
                "
                hide-details
                hide-selected
                item-text="text"
                item-value="value"
                outline
              >
              </v-autocomplete>
            </v-flex>
            <v-flex md4 pl-1>
              <!-- <v-autocomplete
                label="Visa Number"
                v-model="reportFilters.visa_number_id"
                :items="visaNumbersTV"
                hide-details
                hide-selected
                item-text="text"
                item-value="value"
                outline
                clearable
              >
              </v-autocomplete> -->
            </v-flex>
            <v-flex md6 class="text-xs-right">
              <!-- <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    color="primary"
                    fab
                    small
                    dark
                    @click="isSearchModal = true"
                  >
                    <v-icon>search</v-icon>
                  </v-btn>
                </template>
                <span>Advance Search</span>
              </v-tooltip> -->
            </v-flex>
          </v-layout>

          <!-- <content-loader v-if="isLoadingContent"></content-loader> -->
          <list-loader v-if="isLoadingContent"></list-loader>

          <div class="simple-table-container" id="daily-expense-report" v-else>
            <div class="hidden-screen-only report-header text-center">
              <div class="head">
                {{ settings && settings.company_name }}
              </div>
              <div class="address">
                {{ settings && settings.company_address }}
              </div>
              <hr />
              <br />
              <div class="title">Company Wise Candidate Report</div>
              Company Name: {{ employer.name }}<br />
              <!-- ID Number: {{ employer.id_no }} &nbsp;
              <span v-if="visaNumber.visa_no">Visa Number: {{ visaNumber.visa_no }}</span
              ><br /> -->
            </div>
            <table class="table table-bordered">
              <tr>
                <th>Sl.</th>
                <th>Passenger Name</th>
                <th>Passport</th>
                <th>Profession</th>
                <th>Agent</th>
                <th>Company</th>
                <th>Medical Status</th>
              </tr>
              <tr v-for="(item, index) in reportData" :key="item.id">
                <td>{{ index + 1 }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.passport_number }}</td>
                <td>{{ item.profession }}</td>
                <td>{{ item.agents___name }}</td>
                <td>{{ item.employers___name }}</td>
                <td>{{ item.medical_status }}</td>
              </tr>
              <!-- <tr>
                <td colspan="6" class="report-sum text-center">
                  Total Expenses &nbsp;&nbsp; tk. {{ reportSum }}
                </td>
              </tr> -->
            </table>
          </div>
          <v-card-actions>
            <v-btn flat @click="print()">Print</v-btn>
            <!-- <v-btn flat >Explore</v-btn> -->
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- <v-dialog v-model="isSearchModal" scrollable persistent max-width="500px">
      <AdvanceSearch
        :rfilters="reportFilters"
        @cancelled="isSearchModal = false"
        :hide="['agent']"
      />
    </v-dialog> -->
  </div>
</template>

<script>
import { ContentLoader, ListLoader } from "vue-content-loader";
// import AdvanceSearch from "../../SearchModal";
import { columnSum, getTV } from "../../../mdsir/MdsirUtils";
import * as _ from "underscore";

export default {
  components: {
    ContentLoader,
    ListLoader,
    // AdvanceSearch,
  },
  data: () => ({
    isSearchModal: false,
    isLoadingContent: false,
    invoiceDateMenu: false,
    invoiceDateMenu2: false,
    reportFilters: {
      date: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      employer_id: null,
      visa_number_id: null,
    },
    employers: [],
    visaNumbers: [],
    reportData: [],
  }),

  computed: {
    // reportSum() {
    //   return columnSum(this.reportData, "amount_sum");
    // },
    employer() {
      const { employer_id } = this.reportFilters;
      let employer = {
        name: "",
        id_no: "",
      };

      if (employer_id) {
        employer = this.employers.find((r) => (r.id == employer_id));
      }

      return employer;
    },

    visaNumber() {
      const { visa_number_id } = this.reportFilters;
      let visaNums = {
        visa_no: "",
      };

      if (visa_number_id) {
        visaNums = this.visaNumbers.find((r) => (r.id == visa_number_id));
      }

      return visaNums;
    },

    visaNumbersTV() {
      const visaNums =
        this.reportFilters && this.reportFilters.employer_id
          ? this.visaNumbers.filter(
              (r) => r.employer_id == this.reportFilters.employer_id
            )
          : this.visaNumbers;
      return getTV(visaNums, {
        textField: "visa_no",
        valueField: "id",
        isDeselect: false,
      });
    },
  },

  watch: {
    reportFilters: {
      handler: _.debounce(function (val, oldVal) {
        this.getDataFromApi();
      }, 1500),
      deep: true,
    },
    // reportFilters: {
    //   handler: function (val, oldVal) {
    //     this.getDataFromApi();
    //   },
    //   deep: true,
    // },
  },

  created() {},

  mounted() {
    this.loadFormData();
    // this.getDataFromApi();
  },

  methods: {
    getTV: getTV,
    async loadFormData() {
      const employerRes = await this.get("/employers");
      this.employers = employerRes.data.data;
      const visaNoRes = await this.get("/visa_numbers");
      this.visaNumbers = visaNoRes.data.data;
    },
    getDataFromApi() {
      this.isLoadingContent = true;
      this.get("/candidate_medical_report", this.reportFilters).then((response) => {
        this.reportData = response.data;
        this.isLoadingContent = false;
      });
    },
    print() {
      this.$htmlToPaper("daily-expense-report");
    },
  },

  beforeDestroy() {},
};
</script>

<style scoped>
.simple-table-container {
  overflow: auto;
}
.table {
  border-collapse: collapse;
  width: 100%;
}
.table th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #bebebe;
}

.table td,
.table th {
  border: 1px solid #ddd;
  padding: 8px;
}

.table td.report-sum {
  padding: 6px;
  text-align: center;
  background-color: #0f0f0f0e;
  font-size: 20px;
  font-weight: bold;
}
</style>
